import minmaxUtils from "_src/engine/utility/minmax";

import { vec3 } from "_src/libs/gl-matrix";

const vec3Tmp = vec3.create();

export function recalculateBoundings(positionsArray, toWorld, boxes, status) {

  const minmaxWorld = minmaxUtils.reset([]);

  let chunkCounter = 0;
  while (status.active && chunkCounter < positionsArray.length) {

    const positions = positionsArray[chunkCounter];

    const minmaxLocal = minmaxUtils.reset([]);

    recalculateBounding(positions, toWorld, minmaxWorld, minmaxLocal);

    boxes.push(minmaxLocal);

    ++chunkCounter;
  }

  if (!status.active) {
    return null;
  }

  return minmaxWorld;

}

export function recalculateBounding(positions, toWorld, minmaxWorld, minmaxLocal) {

  for (let j = 0; j < positions.length; j+=3) {

    const vertex = vec3.set(vec3Tmp, positions[j], positions[j + 1], positions[j + 2]);

    minmaxUtils.expandPoint(minmaxLocal, vertex);
    vec3.transformMat4(vertex, vertex, toWorld);
    minmaxUtils.expandPoint(minmaxWorld, vertex);

  }

}
